import { createRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Card, EmptyState, Screen, Skeleton } from "../../shared/ui/index.js";
import { Stagger, Item } from "../../shared/motion.js";
import { fmtDate } from "../../shared/format.js";
import { Shell } from "../../app/Shell.js";
import { requireAuth } from "../../app/guards.js";
import { rootRoute } from "../../app/root-route.js";
import { useClients } from "./clients.api.js";
import { CreateClientDialog } from "./CreateClientDialog.js";

export const adminClientsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/clients",
  beforeLoad: requireAuth("admin"),
  component: () => (
    <Shell>
      <ClientsScreen />
    </Shell>
  ),
});

function ClientsScreen() {
  const { data, isLoading } = useClients();
  const [open, setOpen] = useState(false);

  return (
    <Screen
      title="Comptes clients"
      action={<Button onClick={() => setOpen(true)}>Nouveau client</Button>}
    >
      {isLoading ? (
        <Skeleton count={3} className="h-20" />
      ) : data && data.items.length > 0 ? (
        <Stagger className="flex flex-col gap-2">
          {data.items.map((c) => (
            <Item key={c.id}>
              <Card className="!p-4">
                <p className="font-medium text-stone-900">{c.name}</p>
                <p className="text-sm text-stone-500">{c.email}</p>
                <p className="text-xs text-stone-400">
                  créé le {fmtDate(c.createdAt)} ·{" "}
                  {c.lastLoginAt ? `dernière connexion ${fmtDate(c.lastLoginAt)}` : "jamais connecté"}
                </p>
              </Card>
            </Item>
          ))}
        </Stagger>
      ) : (
        <EmptyState>Aucun client.</EmptyState>
      )}
      {open && <CreateClientDialog onClose={() => setOpen(false)} />}
    </Screen>
  );
}
